import { DropdownMenu, DropdownMenuItem, TextButton, Tooltip, Typography } from 'seagull';
import { useTestIds } from 'seagull/utils/TestIds';
import styles from "./AddNewItemButtons.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AddNewItemButtons = _ref => {
  let {
    serviceOptions,
    handleAddServiceFromAgreement,
    handleAddOutOfScopeCharge,
    handleAddServiceInStages
  } = _ref;
  const {
    AddNewItemButtonsTID
  } = useTestIds();
  const onAddService = (serviceId, stageNumber, billingStages) => {
    if (stageNumber && billingStages) {
      handleAddServiceInStages({
        serviceId,
        stageNumber,
        billingStages
      });
    } else {
      handleAddServiceFromAgreement({
        serviceId
      });
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsx(TextButton, {
      underline: false,
      "data-testid": AddNewItemButtonsTID.AddCharge(),
      onClick: handleAddOutOfScopeCharge,
      children: "+ Add an out of scope charge"
    }), serviceOptions.length > 0 ? /*#__PURE__*/_jsx(DropdownMenu, {
      hAlign: "left",
      maxHeight: 200,
      width: 320,
      target: /*#__PURE__*/_jsx(TextButton, {
        underline: false,
        "data-testid": AddNewItemButtonsTID.AddService(),
        children: "+ Add a service listed in the agreement"
      }),
      children: serviceOptions.map((_ref2, index) => {
        let {
          name,
          costString,
          disabledReason,
          id,
          stageNumber,
          billingStages
        } = _ref2;
        return /*#__PURE__*/_jsxs(DropdownMenuItem, {
          height: 56,
          skin: "primary",
          "data-testid": AddNewItemButtonsTID.ServiceOption(index),
          onClick: () => onAddService(id, stageNumber, billingStages),
          disabled: disabledReason.isDisabled,
          tooltipProps: disabledReason.isDisabled ? {
            title: disabledReason.reasonTooltip,
            placement: 'right'
          } : undefined,
          children: [/*#__PURE__*/_jsx(Typography, {
            ellipsis: true,
            className: styles.menuItem,
            variant: "paragraph1",
            "data-testid": AddNewItemButtonsTID.ServiceOptionTitle(index),
            children: name
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.subtitle,
            children: [/*#__PURE__*/_jsx(Typography, {
              ellipsis: true,
              variant: "paragraph1",
              skin: "secondary",
              children: costString
            }), stageNumber && billingStages && /*#__PURE__*/_jsx(Typography, {
              "data-testid": AddNewItemButtonsTID.ServiceOptionStage(index),
              ellipsis: true,
              variant: "paragraph1",
              skin: "secondary",
              children: "(Stage ".concat(stageNumber, "/").concat(billingStages.length, ")")
            })]
          })]
        }, id);
      })
    }) : /*#__PURE__*/_jsx(Tooltip, {
      title: "No manual services are available for billing.",
      placement: "bottom-start",
      children: /*#__PURE__*/_jsx(Typography, {
        skin: "disabled",
        variant: "paragraph1",
        "data-testid": AddNewItemButtonsTID.AddServiceTooltip(),
        children: "+ Add a service listed in the agreement"
      })
    })]
  });
};
export default AddNewItemButtons;